import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { RenderedFormService } from '@app/shared/components/rendered-form/rendered-form.service';
import { SectionType } from '@state/form';
import { FormWizardQuery, NextEvent } from '@state/form-wizard';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-investment-profile-summary',
  styleUrls: ['./investment-profile-summary.component.scss'],
  templateUrl: './investment-profile-summary.component.html'
})
export class InvestmentProfileSummaryComponent implements OnInit {
  @Output() flBack: EventEmitter<any> = new EventEmitter<any>();
  @Output() flNext: EventEmitter<NextEvent> = new EventEmitter<NextEvent>();
  @Output() flFinalSubmit: EventEmitter<any> = new EventEmitter<any>();

  isSubmitting$ = this.formWizardQuery.isSubmitting$;
  requiresProviderAccess = false;
  splicedForm: any;
  submitted = false;

  constructor(public renderedFormService: RenderedFormService, private formWizardQuery: FormWizardQuery) {}

  ngOnInit() {
    this.submitted = false;
    this.setRequiresProviderAccess();
    this.setSplicedForm();
  }

  confirmProfile(): void {
    this.submitted = true;
    this.flFinalSubmit.emit();
  }

  next(): void {
    this.flNext.emit({ skipSave: true });
  }

  revertSelectedProfile(): void {
    this.renderedFormService.dynamicModels = {};
    this.flBack.emit();
  }

  removeSplicedFormSection(sectionName: string): void {
    let indexOfSectionToRemove = this.splicedForm.sections.findIndex(
      (section) => section.type === sectionName
    );

    if (indexOfSectionToRemove > -1) {
      let newSections = this.splicedForm.sections.slice();
      newSections.splice(indexOfSectionToRemove, 1);
      this.splicedForm.sections = newSections;
    }
  }

  setRequiresProviderAccess(): void {
    let form = { ...this.renderedFormService.form };
    let providerAccessRequest = form.sections.find(
      (section) => section.type === SectionType.ProviderAccessRequest
    );
    let requiresProviderAccess =
      this.renderedFormService.dynamicModels['INVESTMENT.PROVIDER_ACCESS_REQUIRED'] === 'true';
    this.requiresProviderAccess = providerAccessRequest && requiresProviderAccess;
  }

  setSplicedForm(): void {
    this.splicedForm = { ...this.renderedFormService.form };
    this.removeSplicedFormSection(SectionType.InvestmentAccountSelection);
    this.removeSplicedFormSection(SectionType.InvestmentAccountSummary);
    this.removeSplicedFormSection(SectionType.ProviderAccessRequest);
  }

  get valid(): boolean {
    if (!this.splicedForm || this.requiresProviderAccess) return false;

    for (let section of this.splicedForm.sections) {
      if (this.renderedFormService.objectIsVisible(section)) {
        for (let element of section.elements) {
          if (this.renderedFormService.objectIsVisible(element)) {
            if (element.element_object_type === 'form/field' && element.element_object.required) {
              if (
                this.renderedFormService.dynamicModels[element.element_object.custom_variable_key] === null
              ) {
                return false;
              }
            }
          }
        }
      }
    }

    return true;
  }
}
